/* XECAR · "Agregar a cotización" desde la tarjeta sin salir de la página */
(() => {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-xe-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.xe-ca__add');
    const txt = btn.querySelector('.xe-ca__txt');
    btn.classList.add('is-busy');
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const r = await fetch(addUrl + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');
      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections && data.sections['cart-icon-bubble'];
      if (bubble && html) {
        const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      txt.textContent = 'Agregado';
      if (!form.parentElement.querySelector('.xe-ca__view')) {
        const a = document.createElement('a');
        a.className = 'xe-ca__view';
        a.href = (window.routes && window.routes.cart_url) || '/cart';
        a.textContent = 'Ver mi cotización →';
        form.parentElement.appendChild(a);
      }
      setTimeout(() => { btn.classList.remove('is-done'); txt.textContent = 'Agregar otra'; }, 2600);
    } catch (err) {
      btn.classList.remove('is-busy');
      txt.textContent = 'Inténtalo de nuevo';
      console.error(err);
    }
  });
})();
